import React from 'react';
import { Button, Typography, Box, Container, Grid, Stack } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { IMAGES, PHONE_DISPLAY, PHONE_HREF } from '../theme';
import { useQuote } from './QuoteDialog';
export function Hero() {
  const {
    openQuote
  } = useQuote();
  return <Box sx={{
    position: 'relative',
    minHeight: {
      xs: '88vh',
      md: '90vh'
    },
    display: 'flex',
    alignItems: 'center',
    py: {
      xs: 8,
      md: 0
    },
    backgroundImage: `linear-gradient(rgba(26, 54, 93, 0.72), rgba(26, 54, 93, 0.88)), url(${IMAGES.hero})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    color: 'white'
  }} data-id="element-60">
      <Container maxWidth="lg" data-id="element-61">
        <Grid container data-id="element-62">
          <Grid item xs={12} md={8} lg={7} data-id="element-63">
            <Box sx={{
            mb: {
              xs: 2.5,
              md: 3
            },
            display: 'inline-flex',
            alignItems: 'center',
            bgcolor: 'rgba(245, 176, 65, 0.18)',
            px: {
              xs: 1.25,
              md: 2
            },
            py: {
              xs: 0.5,
              md: 1
            },
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'secondary.main'
          }} data-id="element-64">
              <LocationOnIcon color="secondary" sx={{
              mr: 0.75,
              fontSize: {
                xs: 15,
                md: 20
              }
            }} data-id="element-65" />
              <Typography color="secondary.main" fontWeight="bold" sx={{
              fontSize: {
                xs: '0.65rem',
                md: '0.8rem'
              },
              letterSpacing: {
                xs: 0.5,
                md: 1
              },
              textTransform: 'uppercase',
              lineHeight: 1.3
            }} data-id="element-66">
                Serving Brentwood, CA & Surrounding Areas
              </Typography>
            </Box>
            <Typography variant="h1" sx={{
            fontSize: {
              xs: '2.75rem',
              sm: '3.5rem',
              md: '4.5rem'
            },
            mb: {
              xs: 2,
              md: 3
            },
            lineHeight: 1.05,
            letterSpacing: '-0.01em'
          }} data-id="element-67">
              Transform Your{' '}
              <Box component="span" sx={{
              color: 'secondary.main'
            }} data-id="element-68">
                Outdoor Living
              </Box>{' '}
              Space
            </Typography>
            <Typography sx={{
            mb: {
              xs: 4,
              md: 5
            },
            fontWeight: 400,
            opacity: 0.85,
            lineHeight: 1.6,
            maxWidth: '600px',
            fontSize: {
              xs: '0.95rem',
              md: '1.5rem'
            }
          }} data-id="element-69">
              Custom patio covers and pergolas designed and built to enhance
              your home's beauty and provide year-round comfort.
            </Typography>
            <Stack direction={{
            xs: 'column',
            sm: 'row'
          }} spacing={1.5} data-id="element-70">
              <Button variant="contained" color="secondary" size="large" onClick={openQuote} fullWidth sx={{
              fontSize: {
                xs: '1rem',
                md: '1.1rem'
              },
              py: 1.5,
              px: 4,
              width: {
                xs: '100%',
                sm: 'auto'
              }
            }} data-id="element-71">
                Get Your Free Estimate
              </Button>
              <Button variant="outlined" size="large" href={PHONE_HREF} fullWidth sx={{
              color: 'white',
              borderColor: 'rgba(255,255,255,0.6)',
              '&:hover': {
                borderColor: 'secondary.main',
                bgcolor: 'rgba(255,255,255,0.1)'
              },
              fontSize: {
                xs: '1rem',
                md: '1.1rem'
              },
              py: 1.5,
              px: 4,
              width: {
                xs: '100%',
                sm: 'auto'
              }
            }} data-id="element-72">
                Call {PHONE_DISPLAY}
              </Button>
            </Stack>

            <Stack direction={{
            xs: 'column',
            sm: 'row'
          }} spacing={{
            xs: 1.25,
            sm: 3
          }} sx={{
            mt: {
              xs: 4,
              md: 6
            }
          }} data-id="element-73">
              {['Licensed & Insured', 'Custom Designs', 'Expert Installation'].map(text => <Stack key={text} direction="row" spacing={1} alignItems="center" data-id="element-74">
                  <CheckCircleOutlineIcon color="secondary" sx={{
                fontSize: {
                  xs: 18,
                  md: 24
                }
              }} data-id="element-75" />
                  <Typography fontWeight="500" sx={{
                fontSize: {
                  xs: '0.875rem',
                  md: '1rem'
                }
              }} data-id="element-76">
                    {text}
                  </Typography>
                </Stack>)}
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>;
}